import { Input, Button } from '@bancobarigui/barihaus';
import { MenuOutlined, PlusOutlined } from '@ant-design/icons';

interface AddItemInputProps {
  value: string;
  onChange: (value: string) => void;
  onAdd: () => void;
  onCancel: () => void;
  onToggle: () => void;
  placeholder: string;
  buttonLabel: string;
  isVisible: boolean;
}

export function AddItemInput({
  value,
  onChange,
  onAdd,
  onCancel,
  onToggle,
  placeholder,
  buttonLabel,
  isVisible,
}: AddItemInputProps) {
  if (!isVisible) {
    return (
      <Button
        type="link"
        size="small"
        icon={<PlusOutlined />}
        onClick={onToggle}
        className="text-blue-600 font-medium p-0"
      >
        {buttonLabel}
      </Button>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <MenuOutlined className="text-gray-400" />
        <Input
          size="middle"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onPressEnter={onAdd}
          placeholder={placeholder}
          autoFocus
          className="flex-1"
        />
        <Button
          type="text"
          size="small"
          className="text-blue-500 hover:bg-blue-50 rounded-full"
          icon={<PlusOutlined />}
          onClick={onAdd}
          children={undefined}
        />
      </div>
      <Button
        type="link"
        size="small"
        onClick={onCancel}
        className="text-gray-500 p-0"
      >
        Cancelar
      </Button>
    </div>
  );
}
